import { useCallback, useState, useEffect } from 'react';
import fscreen from '../utils/fscreen';

export default function useFullScreenToggle() {
  const [isFullScreen, setIsFullScreen] = useState(!!fscreen.fullscreenElement);

  useEffect(() => {
    const onFullScreenChange = () => setIsFullScreen(!!fscreen.fullscreenElement);
    fscreen.addEventListener('fullscreenchange', onFullScreenChange);
    return () => {
      fscreen.removeEventListener('fullscreenchange', onFullScreenChange);
    };
  }, []);

  const toggleFullScreen = useCallback((element) => {
    isFullScreen ? fscreen.exitFullscreen() : fscreen.requestFullscreen(element);
  }, [isFullScreen]);

  return [isFullScreen, toggleFullScreen];
}
